import React, { useEffect, useRef } from "react";
import { languageHelper } from "../../config/helperFunctions";

function KOT({ data, basicInfo, handlePrint, printer, invoice }) {
  const defaultLang =
    invoice.invoice_lang === "default"
      ? localStorage.getItem("rms-lang") || "text_en"
      : invoice.invoice_lang === "Arabic"
      ? "text_ar"
      : "text_en";
  const kotRef = useRef(null);
  useEffect(() => {
    handlePrint(printer, kotRef);
  }, [handlePrint, printer]);
  return (
    <div ref={kotRef} className="flex justify-center my-4">
      <div className="w-full px-8 py-4 text-2xl">
        <div className="text-center mb-6">
          <h2 className="font-bold">{languageHelper("KOT", defaultLang)}</h2>
          <p className="font-semibold">
            {languageHelper("Order No", defaultLang)}: {Number(basicInfo?.token_no)}
          </p>
        </div>

        <div className="mb-4 text-center">
          <p>
            <strong>{languageHelper("Invoice No", defaultLang)}:</strong>{" "}
            {basicInfo?.sale_no}
          </p>
          <p>
            <strong>{languageHelper("Date", defaultLang)}:</strong> {basicInfo?.date_time}
          </p>
          <p>
            <strong>{languageHelper("Customer", defaultLang)}:</strong>{" "}
            {basicInfo.customer?.name}
          </p>
          <p>
            <strong>{languageHelper("Order Type", defaultLang)}:</strong>{" "}
            {basicInfo.order_type?.type}
          </p>
        </div>

        <div className="mb-2">
          <div className="grid grid-cols-3 border-b border-gray-500 font-semibold">
            {/* <span className="mx-1">SN</span> */}
            <span className="mx-1">{languageHelper("Item", defaultLang)}</span>
            <span className="mx-1 text-end">{languageHelper("Qty", defaultLang)}</span>
          </div>
        </div>

        <div className="mb-2">
          {data?.map((order, index) => (
            <div
              key={index}
              className=" border-b border-gray-300 py-2 space-y-2"
            >
              <div className="grid grid-cols-3">
                {/* <span className="mx-1">{index + 1}</span> */}
                <span className="ml-8 break-words text-wrap">
                  {order.food_menu.name}
                </span>
                <span className="mx-1 text-end">{order.qty}</span>
              </div>
              {order.modifiers.map((mod, index) => (
                <div key={index}>
                  <p className="ml-8">{mod.name}</p>
                </div>
              ))}
              {order.menu_note && (
                <div>
                  <p className="ml-8">
                    {languageHelper("Note", defaultLang)}: {order.menu_note}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-4">
          <p className="text-center font-semibold">
            {languageHelper("Total Item(s)", defaultLang)}: {basicInfo?.total_items}
          </p>
        </div>
      </div>
    </div>
  );
}

export default KOT;
